<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-0 mb-sm-3" />
        </b-col>
      </b-row>
    </b-container>
    <b-container class="px-0 px-sm-3 overflow-hidden">
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        body-bg-variant="light"
        border-variant="dark"
        body-class="p-1 p-sm-3"
        class="main-card"
      >
        <template #header class="card-header px-0">
          <router-link to="/">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </template>
        <b-row>
          <b-col>
            <b-card body-class="p-2" class="shadow-sm" border-variant="white">
              <h5 class="m-0">
                <i class="fas fa-award"></i> ผลรางวัล
              </h5>
            </b-card>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <b-card body-class="p-2" class="shadow-sm" border-variant="white">
              <label>
                <i class="fas fa-calendar-alt"></i> วันที่
              </label>
              <!-- <div class="input-group date" id="datetimepicker4" data-target-input="nearest">
                <input
                  type="text"
                  class="form-control datetimepicker-input mb-0"
                  data-target="#datetimepicker4"
                  id="dt"
                  data-container="body"
                  data-toggle="datetimepicker"
                />
                <div
                  class="input-group-append"
                  data-target="#datetimepicker4"
                  data-toggle="datetimepicker"
                >
                  <button class="btn btn-outline-secondary">
                    <i class="fas fa-calendar my-0"></i>
                  </button>
                </div>
              </div> -->
              <b-form-datepicker :max="maxDate" v-model="lottoDate" locale="th" class="mb-2"></b-form-datepicker>
            </b-card>
          </b-col>
        </b-row>
        <LottoDashboard :lottoDate="lottoDate" />
      </b-card>
    </b-container>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";

// Include Component
import TopBarMember from "@/components/TopBarMember.vue";
import FooterIndex from "@/components/Footer.vue";
import LottoDashboard from "@/components/LottoDashboard.vue";
import axios from "axios";
import moment from "moment";

export default {
  name: "Result",
  props: ['page'],
  components: {
    TopBarMember,
    LottoDashboard,
    FooterIndex
  },
  data() {
    return {
      filter: "TODAY",
      maxDate: moment().format("YYYY-MM-DD"),
      lottoDate: moment().format("YYYY-MM-DD"),
      transactions: [
        {
          number: "347387676",
          type: "BET",
          by: "aloneruay",
          to: "ระบบ",
          amount: 300,
          balance: 239,
          date: "11/04/2021 23:39",
          notes: "adfdsfd"
        },
        {
          number: "347387675",
          type: "BET",
          by: "aloneruay",
          to: "ระบบ",
          amount: 300,
          balance: 239,
          date: "11/04/2021 23:39",
          notes: null
        }
      ],
      transactionTypes: [
        {
          code: "BET",
          title: "แทงพนัน"
        }
      ],
      paymentMethods: [
        {
          code: "ATM",
          title: "ATM",
          description: "โอนจากตู้กดเงินสด"
        },
        {
          code: "CDM",
          title: "CDM",
          description: "ฝากผ่านตู้ฝากเงินสด"
        },
        {
          code: "CTC",
          title: "Counter Cashier",
          description: "ฝากเงินผ่านเคาน์เตอร์ธนาคาร"
        },
        {
          code: "INB",
          title: "Internet Banking",
          description: "โอนเงินผ่านหน้าเว็บไซต์"
        },
        {
          code: "MBB",
          title: "Mobile Banking",
          description: "โอนเงินผ่านแอพมือถือ"
        }
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

h5 {
  color: #bd841b;
  font-weight: bold;
}
</style>